/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The ListFavoriteResultModel model module.
* @module model/ListFavoriteResultModel
* @version 1.0.0
*/
export default class ListFavoriteResultModel {
    /**
    * Constructs a new <code>ListFavoriteResultModel</code>.
    * @alias module:model/ListFavoriteResultModel
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>ListFavoriteResultModel</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/ListFavoriteResultModel} obj Optional instance to populate.
    * @return {module:model/ListFavoriteResultModel} The populated <code>ListFavoriteResultModel</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ListFavoriteResultModel();
                        
            
            if (data.hasOwnProperty('Items')) {
                obj['Items'] = ApiClient.convertToType(data['Items'], ['String']);
            }
        }
        return obj;
    }

    /**
    * @member {Array.<String>} Items
    */
    'Items' = undefined;




}
